<template>
  <LayoutTelas
    id="tela__filiais"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <FiliaisCadastroForm
      ref="formFilial"
      :dados="dadosUsuario"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import FiliaisCadastroForm from './FiliaisCadastroForm.vue'
import FilialService from '../../../services/filiais.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'FiliaisCadastro',
  components: {
    FiliaisCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosUsuario: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formFilial.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? FilialService.atualizar(dados)
        : FilialService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosUsuario = await FilialService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-filiais' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__filiais {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
